import React from 'react'
import LKGrid from 'shared/LKGrid'
import { PlainTextContainer } from 'shared/StyledComponents'
import { dateTime as dateTimeFormatter } from 'loankeeper-common/helpers/formatters'
import { constants as DCConstants } from '../../DetailsContainer'

const LKGridConfig = {
  columnConfigs: {
    CalcDate: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
    CalcDate2: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
    Dates_ExpectedEnd: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
    Dates_Overdue: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
    Dates_RealEnd: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
    Dates_Repayment: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
    Dates_Start: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
    GenDate: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
    OperDate: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
    StoreTo: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
  },

  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableColumnsHide: false,
  syncGridState: true,
  enableRowSelection: true,
  enableSorting: false,
  selectLastRow: true,

  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'dbgrd_ci_contractdata',
  },
}

class CreditInfo extends React.Component {
  state = { ErrorMessage: '' }

  handleRowSelected = ({
    node: {
      data: { ErrorMessage },
      selected,
    },
  }) => {
    if (selected) {
      this.setState({ ErrorMessage })
    }
  }

  render() {
    const { ID, data } = this.props

    return (
      <div className="u-flex u-directionColumn u-fluid">
        <div className="u-fluid u-relative">
          <LKGrid
            instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-Creditinfo`}
            rowData={data}
            {...LKGridConfig}
            onRowSelected={this.handleRowSelected}
          />
        </div>

        <PlainTextContainer className="u-margin-5 u-overflowAuto" style={{ height: 90 }}>
          {this.state.ErrorMessage}
        </PlainTextContainer>
      </div>
    )
  }
}

export default CreditInfo
